import React, {
    Component
} from 'react'
import { Link } from 'react-router-dom'
import { actionTypes } from '~/constants';
import _ from 'lodash';
import moment from 'moment-timezone';
import EnhancedTable from '~/widgets/table-enhanced'
import {
    Map,
    Marker,
    Popup,
    TileLayer,
    LayersControl,
    Circle,
    CircleMarker
} from 'react-leaflet';
import fetch from '~/utils/fetch'
import ImageS3SignedUrl from '~/widgets/image-s3-signed-url'
import awsconfig from '~/awsconfig';
import InputClickEditable from '~/widgets/input-click-editable'


const exmarxIconBase = L.Icon.extend({
    // https://leafletjs.com/examples/custom-icons/
    options: {
        iconUrl: '/dist/assets/img/marker-green.svg',
    }
});
const exmarxIcon = new exmarxIconBase();



export default class Container extends Component {
    constructor() {
        super()
        this.state = {
            is_loaded: false,
            map_center: [37.8651, 119.5383]
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        // did we fetch a different report?
        if(prevProps.reports.is_loaded === false && this.props.reports.is_loaded === true && this.props.reports.detail){
            let latitude = _.get(this.props.reports.detail, 'latitude', 0.0);
            let longitude = _.get(this.props.reports.detail, 'longitude', 0.0);
            // console.log(`setState lat lng`)
            this.setState({
                map_center: [latitude, longitude]
            })
        }

        // have we loaded map center from props -> state?
        if(this.state.is_loaded === false && this.props.reports.is_loaded === true){
            let latitude = _.get(this.props.reports.detail, 'latitude', 0.0);
            let longitude = _.get(this.props.reports.detail, 'longitude', 0.0);
            // console.log(`setState lat lng`)
            this.setState({
                is_loaded: true,
                map_center: [latitude, longitude]
            })
        }
    }

    render() {
        console.log(this.props)
        let report = this.props.reports.detail || {};

        if(!this.props.reports.detail || !this.props.users.is_loaded){
            return <div className="card-content" style={{height: '400px'}}><h2>Loading...</h2></div>
        }

        let reporter = this.props.users.list.find(u=>report.reporter === u.cognitoId);
        // console.log(reporter)

        // https://exmarx-reports-api-us-east-1-staging-reportphotosbucket.s3.amazonaws.com/2FB65AE6-395F-4F39-BEED-5C5D8134C0DE/29FA3909-0A50-4DC6-B227-A94983B32A1D.jpg
        // "2FB65AE6-395F-4F39-BEED-5C5D8134C0DE/29FA3909-0A50-4DC6-B227-A94983B32A1D.jpg"
        //     url: `${awsconfig.officeApi}/reports/2FB65AE6-395F-4F39-BEED-5C5D8134C0DE/29FA3909-0A50-4DC6-B227-A94983B32A1D`,
        let photos = [];
        for(let photo of (report.photos || [])){
            photos.push(
                <div className="detail-photo-thumbnail">
                    <Link to={`/app/reports/${report._id}/${this.props.match.params.view}/modal/lightbox/${photo._id}`}>
                        <ImageS3SignedUrl
                            width='80px'
                            height='80px'
                            signedUrlRedirect={`${awsconfig.officeApi}/reports/${report._id}/${photo._id}`}
                        />
                    </Link>
                </div>
            )
        }

        let table =  (
            <EnhancedTable
                data={[
                    {label: 'Accident Number', value: report.accidentNumber},
                    {label: 'Address', value: report.address},
                    {label: 'Latitude', value: report.latitude},
                    {label: 'Longitude', value: report.longitude},
                    {label: 'Reporter', value: report.reporterEmail},
                    {label: 'Created', value: !report.createdAt ? null : moment(report.createdAt).format('MMM Do, YYYY h:mma')},
                    {label: 'Last Activity', value: !report.lastActivityAt ? null : moment(report.createdAt).format('MMM Do, YYYY h:mma')},
                ]}
                order='desc'
                orderBy='createdAt'
                rowsPerPage={10}
                rowClickHandler={(e, r)=>{
                    e.preventDefault();
                    console.log('rowClickHandler!')
                }}
                columns={[
                  {id: 'label', label: 'Key'},
                  {id: 'value', label: 'Value'},
                ]}
                buildTableRow={kv=>{
                    return (
                        <React.Fragment>
                            <EnhancedTable.Cell>{kv.label}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{kv.value}</EnhancedTable.Cell>
                        </React.Fragment>
                    );
                }}
            />
        )

        return (
            <React.Fragment>
                <div className="card-content">
                    <div className="detail-map">
                        <Map center={this.state.map_center} zoom={14}>
                            <Marker position={this.state.map_center} icon={exmarxIcon}>
                                <Popup>{report.address}</Popup>
                            </Marker>
                            <TileLayer
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                                attribution={`&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors &copy; <a href='https://carto.com/attributions'>CARTO</a>`}
                                maxZoom={19}
                            />
                        </Map>
                    </div>
                </div>
                <div className="card-content" style={{paddingTop: 0}}>
                    <div className="detail-flex">
                        <div className="detail-flex-left">
                            <h2 className="detail-heading">
                                Report #{_.get(report, 'accidentNumber', 'LOADING')}
                            </h2>
                            <div className="detail-subheading">
                                {moment(report.createdAt).format('dddd, MMMM Do, YYYY')}
                            </div>
                            <div className="flex-reporter">
                                <div className="flex-reporter-icon">
                                    {!reporter ? '—' : `${reporter.firstname.slice(0, 1)}${reporter.lastname.slice(0,1)}`}
                                </div>
                                <div className="flex-reporter-title">
                                    <div className="flex-reporter-role">
                                        {!reporter ? 'Unknown' : `${reporter.role}`}
                                    </div>
                                    <div className="flex-reporter-name">
                                        {!reporter ? 'Unknown' : `${reporter.firstname} ${reporter.lastname}`}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="detail-flex-right">
                            <div className="detail-flex">
                                <div className="detail-flex-left">
                                    <div className="detail-subheading black">
                                        PHOTOS OF SCENE
                                    </div>
                                </div>
                                <div className="detail-flex-right" style={{textAlign: 'right'}}>
                                    <div className="detail-subheading">
                                        {_.get(report, ['photos', 'length'], 0)} photos
                                    </div>
                                </div>
                            </div>
                            <div className="detail-photos">
                                {_.get(report, ['photos', 'length'], 0) === 0 ? (
                                    <div className="detail-subheading">
                                        There are no photos.
                                    </div>
                                ) : (
                                    <div className="detail-photos-flex">
                                        {photos}
                                    </div>
                                )}
                            </div>
                            <div className="detail-flex" style={{marginTop: '1rem'}}>
                                <div className="detail-flex-left">
                                    <div className="detail-subheading black">
                                        NOTES
                                    </div>
                                </div>
                            </div>
                            <div className="detail-subheading">
                                {report.notes}
                            </div>
                        </div>
                    </div>
                    <h3 style={{marginTop: '1rem'}}>Details</h3>
                </div>
                {table}
            </React.Fragment>
        )
    }
}
